import { useQuery } from '@tanstack/react-query';

import { fetchMeetRoomData } from '@src/api/endpoints/meet';

import { queryKeys } from '@src/utils/queryKeys';

export const useMeetQuery = (roomId: string) =>
  useQuery({
    queryKey: queryKeys.meet.roomData(roomId),
    queryFn: () => fetchMeetRoomData(roomId),
    enabled: !!roomId,
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
